import Vue from 'vue'
import Vuex from 'vuex'
import restMenu from './restMenuModules/restMenu'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  theme: 'bubble',
  position: 'top-right',
  duration: 5000,
  className: 'toast-bubble',
})

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

Vue.prototype.$CDN = CDN

export default new Vuex.Store({
  modules: {
    restMenu,
    strict: debug,
  },
})
